export const LOGIN_EVENT = "LOGIN";
export const SET_PROFILE = "SET_PROFILE";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const SET_ALL_ADMIN = "SET_ALL_ADMIN";

export const SET_ALL_USER = "SET_ALL_USER";
export const CREATE_USER = "CREATE_USER";
export const GET_USER = "GET_USER";
export const UPDATE_USER = "UPDATE_USER";
export const SET_ALL_USER_SELECT = "SET_ALL_USER_SELECT";
export const SET_ALL_CORPORATE_USER = "SET_ALL_CORPORATE_USER";
export const SET_SPEAKER = "SET_SPEAKER";

export const SET_ALL_INSTRUCTOR = "SET_ALL_INSTRUCTOR";
export const SET_ALL_INSTRUCTOR_SELECT = "SET_ALL_INSTRUCTOR_SELECT";
export const CREATE_INSTRUCTOR = "CREATE_INSTRUCTOR";
export const GET_INSTRUCTOR = "GET_INSTRUCTOR";
export const UPDATE_INSTRUCTOR = "UPDATE_INSTRUCTOR";

export const SET_ALL_COURSES = "SET_ALL_COURSES";
export const CREATE_COURSE = "CREATE_COURSE";
export const GET_COURSE = "GET_COURSE";
export const GET_COURSES = "GET_COURSES";
export const UPDATE_COURSE = "UPDATE_COURSE";
export const SET_ALL_COURSES_SELECT = "SET_ALL_COURSES_SELECT";

export const SET_ALL_BLOGS = "SET_ALL_BLOGS";
export const CREATE_BLOG = "CREATE_BLOG";
export const GET_BLOG = "GET_BLOG";
export const GET_BLOGS = "GET_BLOGS";
export const UPDATE_BLOG = "UPDATE_BLOG";
export const SET_ALL_BLOGS_SELECT = "SET_ALL_BLOGS_SELECT";

export const SET_ALL_BOOKS = "SET_ALL_BOOKS";
export const CREATE_BOOK = "CREATE_BOOK";
export const GET_BOOK = "GET_BOOK";
export const GET_BOOKS = "GET_BOOKS";
export const UPDATE_BOOK = "UPDATE_BOOK";
export const SET_ALL_BOOKS_SELECT = "SET_ALL_BOOKS_SELECT";

export const SET_ALL_EVENTS = "SET_ALL_EVENTS";
export const SET_ALL_EVENTS_TITLES = "SET_ALL_EVENTS_TITLES";
export const CREATE_EVENT = "CREATE_EVENT";
export const GET_EVENT = "GET_EVENT";
export const GET_EVENTS = "GET_EVENTS";
export const UPDATE_EVENT = "UPDATE_EVENT";
export const SET_ALL_EVENTS_SELECT = "SET_ALL_EVENTS_SELECT";

export const SET_ALL_EVENT_REGISTRATIONS = "SET_ALL_EVENTS";
export const SET_ALL_EVENT_TITLE_LISTS = "SET_ALL_EVENTS_TITLE_LISTS"
export const GET_EVENT_REGISTRATION = "GET_EVENT_REGISTRATION";
export const GET_EVENT_REGISTRATIONS = "GET_EVENT_REGISTRATIONS";
export const UPDATE_EVENT_REGISTRATION = "UPDATE_EVENT_REGISTRATION";
export const SET_ALL_EVENT_REGISTRATIONS_SELECT = "SET_ALL_EVENT_REGISTRATIONS_SELECT";

export const SET_ALL_SUBSCRIPTIONS = "SET_ALL_SUBSCRIPTIONS";
export const CREATE_SUBSCRIPTION = "CREATE_SUBSCRIPTION";
export const GET_SUBSCRIPTION = "GET_SUBSCRIPTION";
export const GET_SUBSCRIPTIONS = "GET_SUBSCRIPTIONS";
export const UPDATE_SUBSCRIPTION = "UPDATE_SUBSCRIPTION";
export const SET_ALL_SUBSCRIPTION_SELECT = "SET_ALL_SUBSCRIPTION_SELECT";

export const CREATE_VIDEO = "CREATE_VIDEO";
export const GET_VIDEOS = "GET_VIDEOS";
export const GET_VIDEO = "GET_VIDEO";
export const UPDATE_VIDEO = "UPDATE_VIDEO";
export const SET_ALL_VIDEOS = "SET_ALL_VIDEOS";
export const SET_ALL_VIDEO_SELECT = "SET_ALL_VIDEO_SELECT";

export const SET_ALL_SUBSCRIBES = "SET_ALL_SUBSCRIBES";
export const CREATE_SUBSCRIBE = "CREATE_SUBSCRIBE";
export const GET_SUBSCRIBE = "GET_SUBSCRIBE";
export const GET_SUBSCRIBES = "GET_SUBSCRIBES";
export const UPDATE_SUBSCRIBE = "UPDATE_SUBSCRIBE";
export const SET_ALL_SUBSCRIBE_SELECT = "SET_ALL_SUBSCRIBE_SELECT";

export const GET_THANK_YOU_PAGE_SETTING = "GET_THANK_YOU_PAGE_SETTING";
export const UPDATE_THANK_YOU_PAGE_SETTING = "UPDATE_THANK_YOU_PAGE_SETTING";

export const SET_ALL_BOOKSORDER = "SET_ALL_BOOKS_ORDER";
export const GET_BOOK_ORDER = "GET_BOOK_ORDER";
export const GET_BOOKS_ORDER = "GET_BOOKS_ORDER";
export const UPDATE_BOOK_ORDER = "UPDATE_BOOK_OREDER";

export const SET_ALL_NOTIFICATIONS = "SET_ALL_NOTIFICATIONS";
export const CREATE_NOTIFICATION = "CREATE_NOTIFICATION";
export const SAVE_NOTIFICATION_AS_DRAFT = "SAVE_NOTIFICATION_AS_DRAFT";
export const UPDATE_NOTIFICATION_AS_DRAFT = "UPDATE_NOTIFICATION_AS_DRAFT";
export const GET_NOTIFICATION = "GET_NOTIFICATION";
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";
export const SET_ALL_NOTIFICATIONS_SELECT = "SET_ALL_NOTIFICATIONS_SELECT";

//for course
export const SET_ALL_PROMOTIONS = "SET_ALL_PROMOTIONS";
export const CREATE_PROMOTION = "CREATE_PROMOTION";
export const GET_PROMOTION = "GET_PROMOTION";
export const GET_PROMOTIONS = "GET_PROMOTIONS";
export const UPDATE_PROMOTION = "UPDATE_PROMOTION";

//book promotion
export const SET_ALL_BOOKS_PROMOTIONS = "SET_ALL_BOOKS_PROMOTIONS";
export const CREATE_BOOK_PROMOTION = "CREATE_BOOK_PROMOTION";
export const GET_BOOK_PROMOTION = "GET_BOOK_PROMOTION";
export const GET_BOOKS_PROMOTIONS = "GET_BOOKS_PROMOTIONS";
export const UPDATE_BOOK_PROMOTION = "UPDATE_BOOK_PROMOTION";

//coupon code promotion
export const SET_ALL_COUPONCODE_PROMOTIONS = "SET_ALL_COUPONCODE_PROMOTIONS";
export const CREATE_COUPONCODE_PROMOTION = "CREATE_COUPONCODE_PROMOTION";
export const GET_COUPONCODE_PROMOTION = "GET_COUPONCODE_PROMOTION";
export const GET_COUPONCODE_PROMOTIONS = "GET_COUPONCODE_PROMOTIONS";
export const UPDATE_COUPONCODE_PROMOTION = "UPDATE_COUPONCODE_PROMOTION";

export const SET_ALL_REDEEM_COIN = "SET_ALL_REDEEM_COIN";
export const GET_REDEEM_COIN = "GET_REDEEM_COIN";
export const GET_REDEEM_COINS = "GET_REDEEM_COINS";
export const SET_ALL_REDEEM_COIN_SELECT = "SET_ALL_REDEEM_COIN_SELECT";

//subscription promotion
export const SET_ALL_SUBSCRIPTIONS_PROMOTIONS =
  "SET_ALL_SUBSCRIPTIONS_PROMOTIONS";
export const CREATE_SUBSCRIPTION_PROMOTION = "CREATE_SUBSCRIPTION_PROMOTION";
export const GET_SUBSCRIPTION_PROMOTION = "GET_SUBSCRIPTION_PROMOTION";
export const GET_SUBSCRIPTIONS_PROMOTIONS = "GET_SUBSCRIPTION_PROMOTIONS";
export const UPDATE_SUBSCRIPTION_PROMOTION = "UPDATE_SUBSCRIPTION_PROMOTION";

export const SET_ALL_QUIZZES = "SET_ALL_QUIZZES";
export const CREATE_QIZZES = "CREATE_QIZZES";
export const GET_QIZZES = "GET_QIZZES";
export const UPDATE_QIZZES = "UPDATE_QIZZES";

export const SET_ALL_MODULES = "SET_ALL_MODULES";
export const CREATE_MODULE = "CREATE_MODULE";
export const GET_MODULE = "GET_MODULE";
export const UPDATE_MODULE = "UPDATE_MODULE";

export const SET_ALL_LESSONS = "SET_ALL_LESSONS";
export const CREATE_LESSON = "CREATE_LESSON";
export const CREATE_LESSON_RESOURCES = "CREATE_LESSON_RESOURCES";
export const GET_LESSON = "GET_LESSON";
export const UPDATE_LESSON = "UPDATE_LESSON";
export const UPLOAD_LESSON_RESOURCES = "UPLOAD_LESSON_RESOURCES";

export const SET_ALL_CATEGORIES = "SET_ALL_CATEGORIES";
export const CREATE_CATEGORY = "CREATE_CATEGORY";
export const GET_CATEGORY = "GET_CATEGORY";
export const UPDATE_CATEGORY = "UPDATE_CATEGORY";
export const SET_ALL_CATEGORIES_SELECT = "SET_ALL_CATEGORIES_SELECT";

export const SET_ALL_TAGS = "SET_ALL_TAGS";
export const CREATE_TAG = "CREATE_TAG";
export const GET_TAG = "GET_TAG";
export const UPDATE_TAG = "UPDATE_TAG";
export const SET_ALL_TAGS_SELECT = "SET_ALL_TAGS_SELECT";

export const SET_LIST_PARTNERS = "SET_LIST_PARTNERS";
export const SET_PARTNER = "SET_PARTNER";
export const CREATE_PARTNER = "CREATE_PARTNER";
export const UPDATE_PARTNER = "UPDATE_PARTNER";

export const SET_LIST_CORPATATE = "SET_LIST_CORPATATE";
export const SET_ALL_CORPATATE_SELECT = "SET_ALL_CORPATATE_SELECT";
export const SET_CORPATATE = "SET_CORPATATE";
export const CREATE_CORPATATE = "CREATE_CORPATATE";
export const UPDATE_CORPATATE = "UPDATE_CORPATATE";

export const SET_LIST_CORPATATE_USERS = "SET_LIST_CORPATATE_USERS";

export const SET_LIST_ENROLLMENT = "SET_LIST_ENROLLMENT";
export const SET_ENROLLMENT = "SET_ENROLLMENT";
export const CREATE_ENROLLMENT = "CREATE_ENROLLMENT";

export const SET_LIST_EXTENSION_HISTORIES = "SET_LIST_EXTENSION_HISTORIES";
export const SET_EXTENSION_HISTORIES = "SET_EXTENSION_HISTORIES";
export const UPDATE_EXTENSION_HISTORIES = "SET_ENROLLMENT";
export const CREATE_EXTENSION_HISTORIES = "EXTENSION_HISTORIES";

export const SET_ALL_PAYMENTS = "SET_ALL_PAYMENTS";
export const CREATE_PAYMENT = "CREATE_PAYMENT";
export const GET_PAYMENT = "GET_PAYMENT";
export const UPDATE_PAYMENT = "UPDATE_PAYMENT";
export const SET_ALL_PAYMENTS_SELECT = "SET_ALL_PAYMENTS_SELECT";

export const SET_ALL_COMMENT = "SET_ALL_COMMENT";
export const SET_ALL_COMMENT_LESSON = "SET_ALL_COMMENT_LESSON";
export const CREATE_COMMENT = "CREATE_COMMENT";
export const GET_COMMENT = "GET_COMMENT";

export const SET_ALL_FAQS = "SET_ALL_FAQS";
export const UPDATE_FAQS = "UPDATE_FAQS";
export const CREATE_FAQS = "CREATE_FAQS";
export const GET_FAQS = "GET_FAQS";

export const UPDATE_APPCONFIG = "UPDATE_APPCONFIG";
export const GET_APPCONFIG = "GET_APPCONFIG";
